import { useMemo } from 'react';

import { PERMISSIONS, usePlatformAuthorization } from '@/lib/auth';

export const useEconomicalValuePermissions = () => {
  const { hasPlatformPermission } = usePlatformAuthorization();

  const { canCreate, canDelete } = useMemo(
    () => ({
      canCreate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_ECONOMIC_VALUE_DATA]),
      canDelete: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.DELETE_ECONOMIC_VALUE_DATA]),
    }),
    [hasPlatformPermission]
  );

  return {
    canCreate,
    canDelete,
  };
};
